/** @format */
import { commonSharedModule } from './shared.module';

(function () {
    'use strict';

    rangeValidationResultFactory.$inject = ['defineEnum'];
    angular.module(commonSharedModule).factory('RangeValidationResult', rangeValidationResultFactory);

    function rangeValidationResultFactory(defineEnum) {
        return defineEnum(['IMPLICIT', 'MORE_REQUIRED', 'LESS_REQUIRED', 'IMPLICIT_OK', 'OK']);
    }
})();
